import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn (...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}

export function capitalize (str: string): string {
  return `${str.charAt(0).toUpperCase()}${str.slice(1)}`
}
